import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackRatingChip',
  props: {
    value: { type: Number as PropType<Number | undefined>, required: true },
  },
  setup(__props) {

const props = __props;


const colorForRating = computed(() => {
  switch (props.value) {
    case 1: return 'red';
    case 2: return 'red lighten-1';
    case 3: return 'orange';
    case 4: return 'green lighten-3';
    case 5: return 'green';
    default: return 'grey';
  }
});

return { __sfc: true,props, colorForRating }
}

})